<template>
  <v-dialog :value="isShow" max-width="1000" persistent :retain-focus="false">
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Chuyển quản lý học tập
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Chuyển quản lý học tập"
              >
                <common-select-user
                  v-model="gvcn"
                  :items="listGVCN"
                  color="primary"
                  item-text="name"
                  :item-value="(item) => item"
                  :error-messages="errors"
                  placeholder="Tìm kiếm quản lý học tập theo tên"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 px-4 w-full d-flex justify-end">
          <div class="d-flex justify-space-between" style="width:27%">
            <v-btn class="cancel-button" @click="hideModal">Hủy bỏ</v-btn>
            <v-spacer />
            <v-btn class="update-button" @click.prevent="handleSubmit(saveChange)">Xác nhận</v-btn>
          </div>
        </v-card-actions>
      </validation-observer>
    </v-card>
    <ModalConfirmChangeHomeroomTeacher
      v-if="showModal"
      :studentDuoTheSameHomeroomTeacher="studentDuoTheSameHomeroomTeacher"
      :gvcn="gvcn"
      :isShow="showModal"
      :rowSpanGvcn="rowSpanGvcn"
    ></ModalConfirmChangeHomeroomTeacher>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex';
import ModalConfirmChangeHomeroomTeacher from './ModalConfirmChangeHomeroomTeacher.vue';
import StudentCareServices from '../../../services/StudentCareServices';

export default {
  components: { ModalConfirmChangeHomeroomTeacher },
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    selectedItem: {
      type: Array,
      default: () => ([]),
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    filterForm: {
      type: Object,
      default: () => {},
    },
    studentsDuo: {
      type: Array,
      default: () => [],
    },
    listGVCN: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      gvcn: {},
      rowSpanGvcn: 0,
      studentDuoTheSameHomeroomTeacher: [],
    };
  },
  created() {
    Bus.$on('update-gvcn', () => {
      const { oldData, listSelectedId } = this.getDataForUpdateGvcn();
      this.studentDuoTheSameHomeroomTeacher.forEach((e) => {
        e.std.forEach((i) => {
          if (i.is_same) {
            oldData.push({
              id: i.id,
              homeroom_teacher_name: i.homeroom_teacher_name,
            });
            listSelectedId.push(i.id);
          }
        });
      });
      this.updateGvcn(oldData, listSelectedId);
    });
    Bus.$on('close-modal-confirm-change-homeroom-teacher', (value) => {
      this.showModal = value;
    });
  },
  computed: {},
  methods: {
    ...mapActions('student_care', ['apiUpdate']),
    hideModal() {
      this.$emit('close-modal-change-homeroom-teacher', false);
      this.errorMessage = '';
    },
    async saveChange() {
      if (this.studentsDuo && this.studentsDuo.length > 0) {
        const { oldData, listSelectedId } = this.getDataForUpdateGvcn();
        if (listSelectedId.length === 0) {
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Vui lòng chọn khách hàng !!!',
          });
        }

        if (!this.gvcn.id || !this.gvcn.name) {
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Vui lòng chọn quản lý học tập !!!',
          });
        }
        // check validate call api be
        const check = await StudentCareServices.checkUpdateHomeroomTeacher({ ids: listSelectedId });
        if (check && _.isEmpty(check.data)) {
          this.updateGvcn(oldData, listSelectedId);
        } else {
          this.rowSpanGvcn = 0;
          this.studentDuoTheSameHomeroomTeacher = [];
          // eslint-disable-next-line no-restricted-syntax,guard-for-in
          for (const checkKey in check?.data) {
            const item = check?.data[checkKey];
            const itemPush = {
              mobile: checkKey,
            };
            const origin = item?.origin.map((e) => ({
              ...e,
              is_same: false,
            }));
            const same = item?.same.map((e) => ({
              ...e,
              is_same: true,
            }));
            itemPush.std = [...origin, ...same];
            this.rowSpanGvcn += itemPush.std.length;
            this.studentDuoTheSameHomeroomTeacher.push(itemPush);
          }
          this.showModal = true;
        }
      }
      return true;
    },
    async updateGvcn(oldData, listSelectedId) {
      this.appLoadingData(true);
      const result = await this.apiUpdate({
        obj: 'routine',
        data: {
          homeroom_teacher_id: this.gvcn.id,
          homeroom_teacher_name: this.gvcn.name,
        },
        filters: {
          $in__id: listSelectedId,
        },
        oldData,
      });
      this.appLoadingData(false, 0);
      if (result && result.message === 'Success') {
        this.hideModal();
        this.filterForm.checkboxAll = false;
        this.$emit('clear-item-selected');
        this.$swal({
          type: 'success',
          title: 'Thành công',
          text: 'Chuyển quản lý học tập thành công!!!',
        }).then(() => {
          Bus.$emit('duo-care-list-filter');
        });
      } else {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: `Có lỗi khi chuyển quản lý học tập: ${result.message} !!!`,
        });
      }
      return 1;
    },
    getDataForUpdateGvcn() {
      const listSelectedId = [];
      const oldData = [];
      this.selectedItem.forEach((e) => {
        listSelectedId.push(e.id);
        oldData.push({
          id: e.id,
          homeroom_teacher_name: e.homeroom_teacher_name,
        });
      });
      // this.studentsDuo.forEach(
      //   (contact) => {
      //     if (contact.checkbox) {
      //       listSelectedId.push(contact.id);
      //       oldData.push({
      //         id: contact.id,
      //         homeroom_teacher_name: contact.homeroom_teacher_name,
      //       });
      //     }
      //   },
      // );
      return {
        oldData,
        listSelectedId,
      };
    },
  },
  beforeDestroy() {
    Bus.$off('update-gvcn');
    Bus.$off('close-modal-confirm-change-homeroom-teacher');
  },
};
</script>
<style scoped>
.w-full {
  width: 100%;
}
.update-button {
  background-color: #fd1f6d !important;
  color: white;
}
.cancel-button {
  background: #BDBDBD !important;
  color: white;
}
</style>
